import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-timer-payment',
  standalone: false,
  template: `
    <div class="countdown-timer">
      <div class="countdown-wrapper">
        <i class="pi pi-clock"></i>
        <span class="countdown-text">Session expires in: </span>
        <span class="countdown-time">{{ formattedTime }}</span>
      </div>
    </div>
  `,
  styles: [
    `
      .countdown-timer {
        @include mixins.flex;
        align-items: center;
        color: #ff6b35;
        font-weight: 500;

        .countdown-wrapper {
          @include mixins.flex;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .countdown-time {
          font-weight: 600;
          color: #ff6b35;
        }
      }
    `
  ]
})
export class TimerPaymentComponent implements OnInit, OnDestroy {
  @Output() timeoutExpired = new EventEmitter<void>();

  readonly TOTAL_SECONDS = environment.PAYMENT_TIMEOUT_SECONDS;
  remainingSeconds = this.TOTAL_SECONDS;

  private timerSub?: Subscription;

  ngOnInit(): void {
    this.startTimer();
  }

  private startTimer(): void {
    this.timerSub = interval(1000).subscribe(() => {
      this.remainingSeconds--;

      if (this.remainingSeconds <= 0) {
        this.stopTimer();
        this.timeoutExpired.emit();
      }
    });
  }

  private stopTimer(): void {
    this.timerSub?.unsubscribe();
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  get formattedTime(): string {
    const minutes = Math.floor(this.remainingSeconds / 60);
    const seconds = this.remainingSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
